/* eslint-disable react-hooks/exhaustive-deps */
import { Backdrop, Box, Button, CircularProgress, Divider, Fade, Modal, Paper, Table, TableBody, TableCell, TableContainer, TableHead, TableRow, Typography, useMediaQuery } from "@mui/material";
import CloseOutlinedIcon from '@mui/icons-material/CloseOutlined';
import { useTranslation } from "react-i18next";
import { useEffect, useState } from "react";
import { useTheme } from "@emotion/react";
import { formatPrice } from "../../../utils";
import DriverPaymentService from "../../../services/driverPaymentService";


const ViewDriverPaymentModal = ({ open,
    handleClose,
    driverPaymentId }) => {
    const { t, i18n } = useTranslation();
    const theme = useTheme();
    const isTablet = useMediaQuery(theme.breakpoints.down('md'));
    const isMobile = useMediaQuery(theme.breakpoints.down('sm'));
    const isEn = i18n.language === 'en';
    const tableHeadingStyle = { fontWeight: 'bold', backgroundColor: theme.palette.customGrey.pdfTable };

    const [driverPayment, setDriverPayment] = useState({});
    const [isModalLoading, setIsModalLoading] = useState(true);

    const fetchDriverPayment = async () => {
        try {
            const data = await DriverPaymentService.fetchOne(driverPaymentId);
            setDriverPayment(data);
            setIsModalLoading(false);
        } catch (error) {
            console.error('Error fetching driver payment:', error);
        }
    };

    useEffect(() => {
        setIsModalLoading(true);
        if (open) {
            fetchDriverPayment();
        }
    }, [open]);


    return (
        <Modal
            aria-labelledby="transition-modal-title"
            aria-describedby="transition-modal-description"
            aria-hidden="false"
            aria-modal="true"
            open={open}
            onClose={handleClose}
            closeAfterTransition
            slots={{ backdrop: Backdrop }}
            slotProps={{
                backdrop: {
                    timeout: 500,
                },
            }}
        >
            <Fade in={open}>
                <Box
                    sx={{
                        position: 'absolute',
                        top: '50%',
                        left: '50%',
                        transform: 'translate(-50%, -50%)',
                        width: isTablet ? '98%' : '90%',
                        bgcolor: 'background.paper',
                        borderRadius: 2,
                        boxShadow: 24,
                        p: isMobile ? 1 : 4,
                        height: '90vh',
                        overflowY: 'scroll'
                    }}
                >
                    {isModalLoading ? <Box sx={{ justifyContent: 'center', display: 'flex', my: 10 }} >
                        <CircularProgress color="primary" size={28} />
                    </Box>
                        : <Box>
                            <Box sx={{
                                display: 'flex',
                                justifyContent: 'space-between'
                            }}>

                                <Typography id="transition-modal-title" variant="h6" component="h2">
                                    {t('driverPaymentInfo')}
                                </Typography>
                                <CloseOutlinedIcon sx={{ cursor: 'pointer' }} onClick={handleClose} />
                            </Box>

                            <Box
                                sx={{
                                    display: 'flex',
                                    flexDirection: isMobile ? 'column' : 'row',
                                    width: '100%'
                                }}>

                                {/* col 1 */}
                                <Box width={isMobile ? '100%' : '50%'}>
                                    <Typography variant="body1" sx={{ mt: 2 }}>
                                        {t('id')}: <span style={{ fontWeight: 'bold' }}>{driverPayment.id}</span>
                                    </Typography>

                                    <Typography variant="body1" sx={{ mt: 2 }}>
                                        {t('driverName')}: <span style={{ fontWeight: 'bold' }}>{driverPayment.driver && driverPayment.driver.name}</span>
                                    </Typography>

                                    <Typography variant="body1" sx={{ mt: 2 }}>
                                        {t('priceAmount')}: <span style={{ fontWeight: 'bold' }}>{formatPrice(driverPayment.priceAmount)}</span>
                                    </Typography>

                                    <Typography variant="body1" sx={{ mt: 2 }}>
                                        {t('totalPrice')}: <span style={{ fontWeight: 'bold' }}>{formatPrice(driverPayment.totalPrice)}</span>
                                    </Typography>

                                </Box>

                                {/* col 2 */}
                                <Box width={isMobile ? '100%' : '50%'}>
                                    <Typography variant="body1" sx={{ mt: 2 }}>
                                        {t('branch')}: <span style={{ fontWeight: 'bold' }}>{driverPayment.branch && driverPayment.branch.name}</span>
                                    </Typography>

                                    <Typography variant="body1" sx={{ mt: 2 }}>
                                        {t('user')}: <span style={{ fontWeight: 'bold' }}>{driverPayment.user && driverPayment.user.name}</span>
                                    </Typography>

                                    <Typography variant="body1" sx={{ mt: 2 }}>
                                        {t('createdAt')}: <span style={{ fontWeight: 'bold' }}>{driverPayment.createdAt}</span>
                                    </Typography>

                                    <Typography variant="body1" sx={{ mt: 2 }}>
                                        {t('driverPrice')}: <span style={{ fontWeight: 'bold' }}>{formatPrice(driverPayment.driverPrice)}</span>
                                    </Typography>
                                </Box>

                            </Box>

                            {/* note */}
                            <Typography variant="body1"
                                sx={{
                                    mt: 1.5,
                                    wordWrap: 'break-word',
                                    overflow: 'hidden',
                                    textOverflow: 'ellipsis',
                                    display: 'block',
                                    maxHeight: '4.5em',
                                    lineHeight: '1.5em'
                                }}>
                                {t('note')}: <span style={{ fontWeight: 'bold' }}>{driverPayment.note}</span>
                            </Typography>

                            <Divider sx={{ mt: 2, mb: 1 }} />

                            <TableContainer
                                component={Paper}
                                // ref={tableContainerRef}
                                id="tableContainer"
                                sx={{
                                    boxShadow: 'none',
                                    border: 1,
                                    borderColor: theme.palette.customGrey.borderInput,
                                    borderRadius: 2,
                                    height: 'calc(100vh - 452px)',
                                    overflowY: 'auto',
                                    width: '100%',
                                }}
                            >
                                <Table stickyHeader aria-label="simple table">
                                    <TableHead
                                        sx={{
                                            position: 'sticky',
                                            top: 0,
                                            zIndex: 1
                                        }}
                                    >
                                        <TableRow>
                                            <TableCell align={isEn ? 'left' : 'right'} sx={tableHeadingStyle}>
                                                {t('number')}
                                            </TableCell>

                                            <TableCell align={isEn ? 'left' : 'right'} sx={tableHeadingStyle}>
                                                {t('id')}
                                            </TableCell>

                                            <TableCell align={isEn ? 'left' : 'right'} sx={tableHeadingStyle}>
                                                {t('invoiceNumber')}
                                            </TableCell>

                                            <TableCell align={isEn ? 'left' : 'right'} sx={tableHeadingStyle}>
                                                {t('receiverPhone')}
                                            </TableCell>

                                            <TableCell align={isEn ? 'left' : 'right'} sx={tableHeadingStyle}>
                                                {t('address')}
                                            </TableCell>

                                            <TableCell align={isEn ? 'left' : 'right'} sx={tableHeadingStyle}>
                                                {t('totalPrice')}
                                            </TableCell>

                                            <TableCell align={isEn ? 'left' : 'right'} sx={tableHeadingStyle}>
                                                {t('driverPrice')}
                                            </TableCell>

                                            <TableCell align={isEn ? 'left' : 'right'} sx={tableHeadingStyle}>
                                                {t('netPrice')}
                                            </TableCell>

                                            <TableCell align={isEn ? 'left' : 'right'} sx={tableHeadingStyle}>
                                                {t('note')}
                                            </TableCell>
                                        </TableRow>
                                    </TableHead>
                                    <TableBody>
                                        {driverPayment.posts.map((post, index) => (
                                            <TableRow
                                                key={post.id} sx={{ '&:last-child td, &:last-child th': { border: 0 } }}>
                                                <TableCell align={isEn ? 'left' : 'right'} component="th" scope="row">{index + 1}</TableCell>
                                                <TableCell align={isEn ? 'left' : 'right'}>{post.id}</TableCell>
                                                <TableCell align={isEn ? 'left' : 'right'}>{post.invoiceNumber}</TableCell>
                                                <TableCell align={isEn ? 'left' : 'right'}>{post.receiverPhone}</TableCell>
                                                <TableCell align={isEn ? 'left' : 'right'}>{post.receiverAddress}, {post.street.name}, {post.street.city.name}</TableCell>
                                                <TableCell align={isEn ? 'left' : 'right'}>{formatPrice(post.totalPrice)}</TableCell>
                                                <TableCell align={isEn ? 'left' : 'right'}>{formatPrice(post.driverPrice)}</TableCell>
                                                <TableCell align={isEn ? 'left' : 'right'}>{formatPrice(post.netPrice)}</TableCell>
                                                <TableCell align={isEn ? 'left' : 'right'}>{post.note}</TableCell>
                                            </TableRow>
                                        ))}
                                    </TableBody>
                                </Table>
                            </TableContainer>

                            <Box sx={{
                                display: 'flex', justifyContent: 'center', alignItems: 'center',
                                mt: 2
                            }}>
                                {/* close */}
                                <Button
                                    variant="outlined"
                                    color="primary"
                                    sx={{ textTransform: 'none', width: 140, height: 40 }}
                                    onClick={handleClose}
                                >
                                    <Box sx={{ display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
                                        <p>{t('close')}</p>
                                        <CloseOutlinedIcon fontSize="small" sx={{ mx: 0.4 }} />
                                    </Box>
                                </Button>

                                <Box width={20}></Box>

                            </Box>
                        </Box>
                    }
                </Box>
            </Fade>
        </Modal>
    );
}

export default ViewDriverPaymentModal;
